import { UseReportFiltersReturn } from '@src/hooks/useReportFilters';
import {
  TReportCommonPayloadWithGroupingAndProducts,
  TReportCommonPayloadWithGrouping,
} from '@src/types';
import dayjs from 'dayjs';

export const buildCommonPayloadWithGroupingAndProducts = (
  filters: UseReportFiltersReturn
): TReportCommonPayloadWithGroupingAndProducts => {
  return {
    start_date: filters.startDate
      ? dayjs(filters.startDate).format('YYYY-MM-DD')
      : null,
    end_date: filters.endDate
      ? dayjs(filters.endDate).format('YYYY-MM-DD')
      : null,
    grouping: filters.selectedGroupBy?.toLowerCase() ?? 'day',
    products:
      filters.selectedProducts.length > 0
        ? filters.selectedProducts
        : undefined,
    compare_to_previous_period: filters.compareToPreviousPeriod,
    compare_to_same_period_previous_year:
      filters.compareToSamePeriodPreviousYear,
  };
};

export const buildCommonPayloadWithGrouping = (
  filters: UseReportFiltersReturn
): TReportCommonPayloadWithGrouping => {
  return {
    start_date: filters.startDate
      ? dayjs(filters.startDate).format('YYYY-MM-DD')
      : null,
    end_date: filters.endDate
      ? dayjs(filters.endDate).format('YYYY-MM-DD')
      : null,
    grouping: filters.selectedGroupBy?.toLowerCase() ?? 'day',
    compare_to_previous_period: filters.compareToPreviousPeriod,
    compare_to_same_period_previous_year:
      filters.compareToSamePeriodPreviousYear,
  };
};

/**
 * Build payload for affiliate commissions API with dates in YYYY-MM-DD format (no time component)
 */
export const buildAffiliateCommissionsPayload = (
  filters: UseReportFiltersReturn
): TReportCommonPayloadWithGrouping => {
  return {
    start_date: filters.startDate
      ? dayjs(filters.startDate).format('YYYY-MM-DD')
      : null,
    end_date: filters.endDate
      ? dayjs(filters.endDate).format('YYYY-MM-DD')
      : null,
    grouping: filters.selectedGroupBy?.toLowerCase() ?? 'day',
    compare_to_previous_period: filters.compareToPreviousPeriod,
    compare_to_same_period_previous_year:
      filters.compareToSamePeriodPreviousYear,
  };
};
